/**
 * Course filter for the provisioning folder list — `all` plus the four
 * classified courses the backend maps PandaDoc folders to (tz-backend.md §3.1).
 */
export const COURSE_FILTER_OPTIONS: { value: string }[] = [
  { value: 'all' },
  { value: 'Cybersecurity' },
  { value: 'DevOps' },
  { value: 'Data Science' },
  { value: 'Python' },
];

/** Currency of the contribution and the agreement (tz-backend.md §3.2). */
export const CURRENCY_OPTIONS = ['USD', 'BYN', 'RUB', 'EUR', 'PLN'] as const;

export const DEFAULT_CURRENCY = 'PLN';
